module.exports = __webpack_public_path__ + "static/media/uparrow.a718e620.svg";